import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-bootstrap';
import Script from 'react-script-tag-18';

import { connect } from 'react-redux';
import config from '../../../../config.js';

import { getTotalWeight } from '../../../Cart/CartActions.js';
import { getConfig } from '../../../Config/ConfigActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import Icon from '../../../../components/Content/Icon.js';
import AddressView from '../../../Address/components/view/AddressView.js';
import Loader from '../../../../components/Loader/Loader.js';

const handleScriptError = () => {
	let url = window.location.href;
	const reloadParam = 'mondialrelayerror=1';
	if(url.indexOf('?') > -1) {
		url += `&${reloadParam}`;
	} else {
		url += `?${reloadParam}`;
	}
	window.location.href = url;
};

// function MondialRelayProvider(props) {
// 	const [loadedScripts, setLoadedScript] = useState([]);
// 	const addLoad = script => {
// 		console.log('Script load add', [...loadedScripts], script);
// 		setLoadedScript([...loadedScripts, script]);
// 	};

// 	const scripts = [
// 		'https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js',
// 		'https://unpkg.com/leaflet/dist/leaflet.js',
// 	];
// 	return (
// 		<Fragment>
// 			{loadedScripts.length}
// 			{loadedScripts.length < scripts.length && <Loader />}
// 			{scripts.filter((script, index) => index === loadedScripts.length).map((script, index) => <Script key={script} src={script} delayMS={index * 2000} onLoad={() => addLoad(script)} onError={handleScriptError} />)}
// 			{loadedScripts.length === scripts.length && <MondialRelaySelector2 {...props} />}
// 		</Fragment>
// 	);
// }

function MondialRelayProvider({ search, items, address, setAddress, isMondialRelayDown }) {
	const [hasError, setHasError] = useState(false);
	const [data, setData] = useState(null);
	const [relayId, setRelayId] = useState(null);

	const scripts = [
		// 'https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js',
		// 'https://unpkg.com/leaflet/dist/leaflet.js',
		// isMondialRelayDown || search.get('mondialrelayerror')
		// ? `${config.url}assets/js/jquery.plugin.mondialrelay.parcelshoppicker.min.js` // BACKUP
		// : 'https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js',
		`${config.url}assets/js/mondialrelay.selector.js`, // BACKUP
	];

    const getAddressFromProvider = () => {
        return {
            ...address,
            name: `${data.Nom || ''} - ${address.name || ''}`,
            street1: data.Adresse1,
            street2: data.Adresse2,
            postalCode: data.CP,
            city: data.Ville,
            country: data.Pays,
            countryCode: data.Pays,
            providerData: data,
            isFromProvider: true,
        };
    };

    const handleSetRelay = event => {
		setRelayId(event.target.value);
    };

    const handleValid = () => {
        // console.log('Validation', data, getAddressFromProvider());

        // Transform provider data to normalize address (map between address fields (ex: Adresse1 => street1))
        // Provider data:
        // Adresse1: "142 AVENUE VICTOR DALBIEZ",
        // Adresse2: null,
        // Available: true,
        // CP: "66000",
        // HoursHtmlTable: "<table class='PR-Hours' border='0' cellspacing='0' cellpadding='0'><tr><th>Lundi</th><td>-</td><td>-</td></tr></table><table class='PR-Hours' border='0' cellspacing='0' cellpadding='0'><tr class='d'><th>Mardi</th><td>09h30-12h00</td><td>14h00-18h00</td></tr></table><table class='PR-Hours' border='0' cellspacing='0' cellpadding='0'><tr><th>Mercredi</th><td>09h30-12h00</td><td>14h00-18h00</td></tr></table><table class='PR-Hours' border='0' cellspacing='0' cellpadding='0'><tr class='d'><th>Jeudi</t...",
        // ID:"005370",
        // Lat:"42,6801141",
        // Letter:"D",
        // Long:"2,8807325",
        // Nature: "D",
        // Nom: "EPICERIE ASIATIQUE JADE OR STO",
        // Pays: "FR",
        // Photo: null,
        // Ville: "PERPIGNAN",
        // Warning : ""

        setAddress(getAddressFromProvider());
    };

    const handleSelectShop = data => {
		console.log('MR::: Set data', data);
		setData(data);
    };

    const initEditor = (retry = 0) => {
		console.log('MondialRelay::: Init editor', retry);
        // Charge le widget dans la DIV d'id "Zone_Widget" avec les paramètres indiqués
        // et renverra le Point Relais sélectionné par l'utilisateur dans le champs d'ID "Retour_Widget"
        if(window?.$ && window.$('#MRProviderWrapper')?.MR_ParcelShopPicker) {
			window.$('#MRProviderWrapper')?.MR_ParcelShopPicker({
				Target: '#relayId', // Selecteur JQuery de l'élément dans lequel sera renvoyé l'ID du Point Relais sélectionné (généralement un champ input hidden)
				Brand: config.mondialrelay.clientId, // Votre code client Mondial Relay
				Country: address.countryCode.trim(), // Code ISO 2 lettres du pays utilisé pour la recherche
				PostCode: address.postalCode.trim(),
				Weight: Math.ceil(getTotalWeight(items) * 1000) || 0,
				DisplayMapInfo: false,
				Responsive: true,
				OnNoResultReturned: () => setHasError(true),
				OnParcelShopSelected: handleSelectShop,
			});
		} else {
			retry < 10 && setTimeout(() => {
				initEditor(retry + 1);
			}, 1000);
		}
    };

	useEffect(() => {
		initEditor();
	}, []);

	useEffect(() => {
		data && handleValid();
	}, [data]);

	return (
		<div>
			{scripts.map((script, index) => <Script key={script} src={script} delayMS={(index + 1) * 1000} onError={handleScriptError} />)}
			<div id="MRProviderWrapper" className="text-center text-secondary" />
			<Form.Control type="text" id="relayId" className="d-none" onChange={handleSetRelay} />

			{data && (
				<div className="ms-3 p-3">
					<h5><FormattedMessage id="addressShipping" defaultMessage="Shipping address" /></h5>
					<AddressView address={getAddressFromProvider()} />
				</div>
			)}

			{hasError && (
				<p className="text-secondary text-center">
					<Icon icon="danger" /> <FormattedMessage id="shippingProviderMRError" defaultMessage="Mondial Relay is not available now. Please contact us to solve your case or choose another delivery." />
				</p>
			)}
		</div>
	);
}
// <Button color="success" block className="my-3" onClick={this.handleValid} disabled={!this.state.data}><FormattedMessage id="shippingDeliveryDetailValidButton" defaultMessage="Valid delivery informations" /> <Icon icon="check" /></Button>
// {!this.state.hasError && <Icon icon="spinner" spin />}

function mapStateToProps(store, props) {
	return {
		isMondialRelayDown: getConfig(store, 'is-mondialrelay-down'),
	};
}

MondialRelayProvider.defaultProps = {
    items: [],
	isMondialRelayDown: '',
};

MondialRelayProvider.propTypes = {
	search: PropTypes.object.isRequired,
    address: PropTypes.object.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
    setAddress: PropTypes.func.isRequired,
	isMondialRelayDown: PropTypes.string,
};

// const MondialRelaySelector2 = connect(mapStateToProps)(withRouter(MondialRelaySelector));

export default connect(mapStateToProps)(withRouter(MondialRelayProvider));
